// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import React, { createContext, useContext } from 'react'
import IUser from './IUser'


interface ISessionContext {
  available: boolean
  booting: boolean
  error: boolean | string | null
  articleContent: string | null
  articlePath: string | null
  loading: boolean
  locale: string
  nav: HTMLIonNavElement
  ready: boolean
  user: IUser
  isAuthenticated(): boolean
  isUnsupportedDevice(): boolean 
  forceAuthenticate(): void
  forceRefresh(): void
  setBooting(value: boolean): void
  setArticleContent(path: string | null): void
  setArticlePath(path: string | null): void
  setLanguage(language: string): void
  setLoading(loading: boolean): void
  setServiceNotAvailable: (available: boolean) => void
  setUser(user: IUser): void
  setError: (error: boolean | string | null) => void
}


const SessionContext: React.Context<ISessionContext> = createContext<ISessionContext>(null!)

const useSession: () => ISessionContext = () => {
    return useContext(SessionContext)
}

export default useSession
export {
    SessionContext
}
export type {ISessionContext}